import type { TrainingMode } from '../types';

export const XP_REWARDS: Record<TrainingMode, number> = {
  flashcards: 5,
  'multiple-choice': 10,
  typing: 15,
  'speed-verbs': 10,
};

export interface GetXpRewardOptions {
  learningMode?: boolean;
}

const LEARNING_MODE_XP_MULTIPLIER = 0.5;
export const MINIMUM_ACCURACY_FOR_XP = 65;

export function getXpReward(mode: TrainingMode, options?: GetXpRewardOptions) {
  const baseReward = XP_REWARDS[mode];

  if (mode === 'typing' && options?.learningMode) {
    return Math.max(1, Math.round(baseReward * LEARNING_MODE_XP_MULTIPLIER));
  }

  return baseReward;
}

export function qualifiesForXp(accuracy: number) {
  return Number.isFinite(accuracy) && accuracy >= MINIMUM_ACCURACY_FOR_XP;
}

export function calculateEarnedXp(mode: TrainingMode, accuracy: number, options?: GetXpRewardOptions) {
  if (!qualifiesForXp(accuracy)) {
    return 0;
  }

  return getXpReward(mode, options);
}